<template>
    <np-responsive>
        <template #label>
        <span>{{label}}</span>
        </template>
        <template #input>
        <div class="form-group ">
            <np-select2  :value="modelValue" @update="update" v-bind="$attrs">
                <option value="">{{lang('select_title')}}</option>
                <option v-for="title in titles" :value="title">{{title}}</option>
            </np-select2>
        </div>
        </template>
    </np-responsive>
</template>
<script>
    import NPSelect2 from './np-select2.vue';

    export default {
        name: 'np-title-select',
        props: ['value', 'label','modelValue'],
        data: function() {
            return {
                titles: ['Mr', 'Mrs', 'Miss']
            };
        },
        components: {
            'np-select2': NPSelect2
        },
        methods: {
            update(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            }
        }
    }
</script>
